import styled from 'styled-components'
import Img from '../common/img'
import { theme } from '../../styles/_variables'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-image: ${props => `url(${props.bg})`};
  background-size: cover;
  filter: blur(8px);
  z-index: -1;
`

export const LoginWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
`

export const LoginBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  background-color: ${props => (props.background ? props.background : theme.color.black)};
  border-radius: 8px;
  flex-direction: column;
  padding: 40px;
  box-shadow: rgb(56, 53, 48) 0px 0px 50px;
  background-size: contain;
  background-position: right;
  background-repeat: no-repeat;
  background-image: ${props => `url(${props.cover})`};
  position: relative;
`

export const Image = styled(Img)`
  width: 50%;
`

export default Wrapper
